/**
 * Category/provider config — shared between client and server.
 * Kept outside any 'use client' component so server components can import it.
 */

import { Film, Tv, BookOpen, Mic2, UtensilsCrossed, MapPin } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const PROVIDER_CONFIG = [
  { label: 'Movie',      value: 'movie',      apiProvider: 'tmdb',          categorySlug: 'movie',      icon: Film },
  { label: 'TV Show',    value: 'tv',         apiProvider: 'tmdb',          categorySlug: 'tv-show',    icon: Tv },
  { label: 'Book',       value: 'book',       apiProvider: 'open_library',  categorySlug: 'book',       icon: BookOpen },
  { label: 'Podcast',    value: 'podcast',    apiProvider: 'itunes',        categorySlug: 'podcast',    icon: Mic2 },
  { label: 'Restaurant', value: 'restaurant', apiProvider: 'google_places', categorySlug: 'restaurant', icon: UtensilsCrossed },
  { label: 'Place',      value: 'place',      apiProvider: 'google_places', categorySlug: 'place',      icon: MapPin },
] as const satisfies ReadonlyArray<{
  label: string;
  value: string;
  apiProvider: string | null;
  categorySlug: string;
  icon: LucideIcon;
}>;

export type ProviderValue = typeof PROVIDER_CONFIG[number]['value'];
